module.exports = __webpack_public_path__ + "static/media/waving-hand.064e1676.png";